import _regeneratorRuntime from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; // @ts-check

import React, { useState } from 'react';
import { Box, Typography, Grid, InputAdornment, TextField, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Icon from '../../../../Icon';
import { useDocumentState, useDocumentDispatch } from '../context/documentContext';
import pathUtil from '../../../../../utils/pathUtil';
import dataSchemasClient from '../../../../../utils/apiClients/dataSchemasClient';
import ModalWindow from '../../../../../modal/Window';
import RepositoryPicker from '../../../../RepositoryPicker';
var useStyles = makeStyles(function (theme) {
  return {
    disabledText: {
      color: theme.palette.text.hint
    },
    listIcon: {
      marginRight: theme.spacing(1),
      fontSize: '1rem'
    },
    list: {
      margin: theme.spacing(0, -3)
    },
    listItem: {
      height: 34,
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(2)
    },
    iconSize: {
      fontSize: '14px'
    }
  };
}, {
  name: 'ECSidebarProperties'
});

var SidebarProperties = function SidebarProperties(_ref) {
  var selectedItem = _ref.selectedItem,
      workspace = _ref.workspace,
      path = _ref.path;
  var classes = useStyles({});
  var documentState = useDocumentState();
  var documentDispatch = useDocumentDispatch();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      filePickerOpen = _useState2[0],
      setFilePickerOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      errorDialogOpen = _useState4[0],
      setErrorDialogOpen = _useState4[1];

  var handleFilePickerChanged =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(files) {
      var schema, basePath, relativeSpreadsheetSource, selectedCsvPath, fileData, sameColumns;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dataSchemasClient.getSchema(workspace, files[0].path);

            case 2:
              schema = _context.sent;
              basePath = pathUtil.getFolderPath(path);
              relativeSpreadsheetSource = pathUtil.relative(files[0].path, basePath);
              selectedCsvPath = pathUtil.absolute(selectedItem.src, basePath);
              fileData = documentState.csvData[selectedCsvPath];
              setFilePickerOpen(false);
              sameColumns = fileData.header.length === schema.Fields.length && fileData.header.every(function (header, index) {
                return header === schema.Fields[index].Name;
              });

              if (sameColumns) {
                documentDispatch({
                  type: 'change_spreadsheetSource',
                  payload: {
                    dataSourceId: selectedItem.id,
                    src: relativeSpreadsheetSource
                  }
                });
              } else {
                setErrorDialogOpen(true);
              }

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleFilePickerChanged(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleDelete = function handleDelete() {
    documentDispatch({
      type: 'remove_spreadsheet',
      payload: selectedItem.id
    });
  };

  return React.createElement("div", null, React.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 2
  }, React.createElement(Grid, {
    item: true,
    container: true,
    justify: "space-between",
    alignItems: "center"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(Typography, {
    variant: "h6"
  }, "Properties")), React.createElement(Grid, {
    item: true
  }, selectedItem && React.createElement(Icon, {
    type: "delete",
    buttonSize: "small",
    onClick: handleDelete,
    className: classes.iconSize
  }))), selectedItem && React.createElement(Grid, {
    item: true,
    xs: true
  }, React.createElement(Typography, {
    gutterBottom: true
  }, "Data"), React.createElement(TextField, {
    fullWidth: true,
    value: pathUtil.cleanPath(selectedItem.src),
    InputProps: {
      endAdornment: React.createElement(Tooltip, {
        title: "Browse"
      }, React.createElement(InputAdornment, {
        position: "end"
      }, React.createElement(Icon, {
        type: "ellipsis-h",
        onClick: function onClick() {
          setFilePickerOpen(true);
        },
        className: classes.iconSize,
        buttonSize: "small"
      })))
    }
  }))), !selectedItem && React.createElement(Typography, {
    className: classes.disabledText
  }, "There are no properties for selected item"), filePickerOpen && React.createElement(RepositoryPicker, {
    lockWorkspace: true,
    workspace: workspace,
    path: path,
    fileExtensions: ['csv'],
    onChange: handleFilePickerChanged,
    onClose: function onClose() {
      setFilePickerOpen(false);
    }
  }), errorDialogOpen && React.createElement(ModalWindow, {
    onClose: function onClose() {
      return setErrorDialogOpen(false);
    },
    overlay: true,
    renderContent: function renderContent() {
      return React.createElement(Box, {
        m: 2
      }, React.createElement(Typography, null, "Can't use the selected file as the source for the current Spreadsheet, the columns are different."));
    },
    footerButtons: {
      submit: {
        children: 'OK',
        onClick: function onClick() {
          return setErrorDialogOpen(false);
        }
      }
    },
    header: "Error",
    style: {
      width: 500
    }
  }));
};

export default SidebarProperties;